import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { IAdProduct } from "../../whatsappAdProducts.types";
import { requestGetAdProduct } from "./getAdProduct.request";

const useAdProduct = (
  id: string | undefined,
  options?: QueryOptions<IAdProduct, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["whatsappAdProduct", `${id}`],
    queryFn: async () => await requestGetAdProduct(id as string),
    enabled: Boolean(id),
    ...options
  });

  return { adProduct: data, ...rest };
};

export default useAdProduct;
